function recalculateTotalSum() {
  const form = document.querySelector(".js-purchase-form");
  if (!form) return;
  let comment = [];
  const defaultPrice = +form.getAttribute("data-default-price");
  let pricePerUnit = +defaultPrice;
  const selector = form.querySelector(".js-purchase-form-select-modificator");
  if (selector) {
    pricePerUnit = +selector.value;
    comment.push(selector.options[selector.selectedIndex].text);
  }
  const quantity = +form.querySelector(".js-purchase-form-counter-input").value;
  const quantitySum = quantity * pricePerUnit;
  let sum = quantitySum;
  const options = form.querySelectorAll(".js-purchase-form-option");
  if (options) {
    [].forEach.call(options, option => {
      if (!option.checked) return;
      sum += +option.value;
      comment.push(option.getAttribute("data-text"));
    });
  }
  document.getElementById("purchase_comment").value = comment.join(", ");
  document.getElementById("purchase_price").value = sum;
  form.querySelector(".js-purchase-form-total-sum").innerHTML = sum;
}

function toggleDisabled(button, isTrue) {
  if (isTrue) return button.setAttribute("disabled", "disabled");
  button.removeAttribute("disabled");
}

function handleCounters() {
  const form = document.querySelector(".js-purchase-form");
  if (!form) return;
  const buttons = form.querySelectorAll(".js-purchase-form-counter-button");
  if (!buttons) return;
  [].forEach.call(buttons, button => {
    const counterBlock = button.closest(".form-counter");
    const input = counterBlock.querySelector("input");
    const minVal = +input.getAttribute("data-min");
    const maxVal = +input.getAttribute("data-max");
    const decButton = counterBlock.querySelector(".js-purchase-form-minus");
    const incButton = counterBlock.querySelector(".js-purchase-form-plus");
    const stepVal = +button.getAttribute("data-step");
    if (+input.value >= maxVal) toggleDisabled(incButton, true);
    if (+input.value <= minVal) toggleDisabled(decButton, true);
    button.addEventListener("click", () => {
      const currentVal = +input.value;
      const newVal = currentVal + stepVal;
      if (newVal < minVal || newVal > maxVal) return;
      input.value = newVal;
      recalculateTotalSum();
      if (newVal > minVal) toggleDisabled(decButton, false);
      if (newVal < maxVal) toggleDisabled(incButton, false);
      if (newVal >= maxVal) toggleDisabled(incButton, true);
      if (newVal <= minVal) toggleDisabled(decButton, true);
    });
  });
}

function handleSelector() {
  const form = document.querySelector(".js-purchase-form");
  if (!form) return;
  const selector = form.querySelector(".js-purchase-form-select-modificator");
  if (!selector) return;
  selector.addEventListener("change", recalculateTotalSum);
}

function handleOptions() {
  const form = document.querySelector(".js-purchase-form");
  if (!form) return;
  const options = form.querySelectorAll(".js-purchase-form-option");
  if (!options) return;
  [].forEach.call(options, option => {
    option.addEventListener("change", recalculateTotalSum);
  });
}

export default () => {
  handleCounters();
  handleSelector();
  handleOptions();
  recalculateTotalSum();
};
